import { HOME } from "../../interfaces/home.interface";

export const homeJson: HOME = {

    heroHome_params: {
        "urlVideo": "https://player.vimeo.com/video/706088405?background=1&autoplay=1&loop=1&byline=0&title=0",
        "preTitleHero": "retailCo.",
        "titleHero": "Damos vida a los locales",
        "mainTextHero": "Expertos en la gestión inmobiliaria para sumar y ser parte del futuro y la transformación del retail",
        "mainButtonTextHero": "Saber más",
        "mainButtonLinkHero": "/quienes-somos"
    },
    twoColArea_params: {
        "sectionId": "quienes",
        "preTitle": "quienes somos",
        "title": "nacemos como gestora de inmuebles especializada en retail.",
        "mainText": "Nuestro alma es joven y nuestro espíritu cuenta con experiencia profesional de reconocido prestigio en el sector inmobiliario, la consultoría estratégica y las finanzas.",
        "mainButtonText": "Ver más",
        "mainButtonLink": "/quienes-somos/"
    },
    imgBig_params: {
        "url": "assets/img/img1-qs.jpg",
        "alt": "quienes somos"
    },
    oneColArea_params: {
        "preTitle": "nuestro objetivo",
        "title": "buscamos generar valor sostenible para nuestros clientes. Sumar en el presente y futuro del retail.",
        "mainText": "Nuestra vocación patrimonialista, pone en valor nuestra cartera de locales a través del arrendamiento, el cambio de uso, su transformación o desinversión.",
        "mainButtonText": "leer más",
        "mainButtonLink": "/quienes-somos/"
    },
    counterUp_params: {
        "data1": 800,
        "txt1": "inmuebles",
        "data2": 214700,
        "txt2": "metros<sup>2</sup>",
        "data3": 18,
        "txt3": "comunidades"
    },
    lineWords_params: {
        title: "nuestro equipo",
        words: ["profesionales", "experiencia", "especialistas", "profesionalidad", "multidisciplinar", "intuición", "ciudad", "global", "local", "comunidad"],
        postWord: "Co"
    },
    oneColAreaButton_params: {
        "mainText": "El talento de un equipo multidisciplinar trae al mercado la oferta en locales más diversificada que suma al futuro del retail.",
        "buttonText": "Ver equipo",
        "buttonLink": "/equipo/"
    },
    carouselTeamHome_items: {
        "item1_imgSrc": "assets/img/img_equipo_jgonzalez.jpg",
        "item1_txtName": "Jorge González Navarro",

        "item2_imgSrc": "assets/img/img_equipo-jmrevuelta.jpg",
        "item2_txtName": "José María Revuelta",

        "item3_imgSrc": "assets/img/img_equipo_iacha.jpg",
        "item3_txtName": "Ignacio Acha",

        "item4_imgSrc": "assets/img/img_equipo_joel.jpg",
        "item4_txtName": "Ángel Joel Rua Rodriguez",

        "item5_imgSrc": "assets/img/img_equipo_cherrera.jpg",
        "item5_txtName": "Carlos Herrera Moriñigo",

        "item6_imgSrc": "assets/img/img_equipo_icanto.jpg",
        "item6_txtName": "Ignacio Cantó Blázquez",

        "item7_imgSrc": "assets/img/img_equipo-sguzman.jpg",
        "item7_txtName": "Soledad Guzmán Azqueta",

        "item8_imgSrc": "assets/img/img_equipo_langelone.jpg",
        "item8_txtName": "Lara Angelone",

        "item9_imgSrc": "assets/img/img_equipo-ichillon.jpg",
        "item9_txtName": "Ignacio Chillón Peñalver",

        "item10_imgSrc": "assets/img/img_equipo-lgonzalez.jpg",
        "item10_txtName": "Luis González Martino",

        "item11_imgSrc": "assets/img/img_equipo_scarracedo.jpg",
        "item11_txtName": "Sara Carracedo Culebras",

        "item12_imgSrc": "assets/img/img_equipo_yredondo.jpg",
        "item12_txtName": "Yolanda Redondo",

        "item13_imgSrc": "assets/img/img_equipo nsanz.jpg",
        "item13_txtName": "Natalia Sanz Franco",

        "item14_imgSrc": "assets/img/img_equipo_dmonge.jpg",
        "item14_txtName": "Daniel Monge",

        "item15_imgSrc": "assets/img/img_equipo_asanchez.jpg",
        "item15_txtName": "Ana Sánchez",

        "item16_imgSrc": "assets/img/img_equipo_vsanchez.jpg",
        "item16_txtName": "Vicente Sánchez"
    },
    marqueeHome_items: [
        {
            "text": "sala de prensa.",
            "grey": true
        },
        {
            "text": "noticias.",
            "grey": false
        },
        {
            "text": "retailCo en medios.",
            "grey": true
        },
        {
            "text": "retailCo ahora.",
            "grey": false
        },
        {
            "text": "somos noticia.",
            "grey": true
        },
        {
            "text": "lo que dicen de nosotros.",
            "grey": false
        },
        {
            "text": "retailCo damos que hablar.",
            "grey": true
        },
        {
            "text": "sala de prensa.",
            "grey": true
        },
        {
            "text": "noticias",
            "grey": false
        },
        {
            "text": "retailCo en medios.",
            "grey": true
        },
        {
            "text": "retailCo ahora.",
            "grey": false
        },
        {
            "text": "somos noticia.",
            "grey": true
        },
        {
            "text": "lo que dicen de nosotros.",
            "grey": false
        },
        {
            "text": "retailCo damos que hablar.",
            "grey": true
        },
        {
            "text": "sala de prensa.",
            "grey": true
        },
        {
            "text": "noticias.",
            "grey": false
        },
        {
            "text": "retailCo en medios.",
            "grey": true
        },
        {
            "text": "retailCo ahora.",
            "grey": false
        },
        {
            "text": "somos noticia.",
            "grey": true
        },
        {
            "text": "lo que dicen de nosotros.",
            "grey": false
        },
        {
            "text": "retailCo damos que hablar.",
            "grey": true
        }

    ],
    marqueeHome_spacer: "\u00A0\u00A0\u00A0\u00A0",
    btnMore_params: {
        "text": "Ver sala de prensa",
        "link": "/sala-de-prensa/"
    },
    threeColAreaButton_params: {
        "preTitle": "#retalk",
        "title": "hablemos de dar vida a los locales. #Retalk la conversación necesaria.",
        "mainText": "Tenemos los ojos y los oidos bien abiertos y queremos compartirlo contigo. La ciudad late en cada decisión que se toma. Alquilar o vender. Dar espacio a proyectos que encajan en las necesidades de un barrio. Crear pequeños centros en cada distrito. Ser parte de la evolución de sociedad.",
        "mainButtonText": "Ir a retalk",
        "mainButtonLink": "/retalk/"
    },
    carouselMainImg: {
        "imgSrc": "assets/img/retalk/007_poster.jpg",
        "imgAlt": "imagen retalk",
        "link": "/retalk/6"
    },
    carouselRetalkHome_items: [
        {
            "imgSrc": "assets/img/retalk/007_int1.jpg",
            "imgAlt": "retalk #7",
            "active": true,
            "link": "/retalk/6"
        },
        {
            "imgSrc": "assets/img/retalk/007_int2.jpg",
            "imgAlt": "retalk #7",
            "active": false,
            "link": "/retalk/6"
        }
    ],
    twoColAreaPhotoButton_params: {
        "preTitle": "CASOS DE ÉXITO",
        "title": "cascorro 23",
        "mainText": "Cascorro 23 representa un edificio emblemático destinado, por su localización y estructura, a ser locomotora comercial del centro de Madrid, en el distrito de Embajadores y la Plaza Mayor.",
        "mainButtonText": "Ver más",
        "mainButtonLink": "/casos-exito/",
        "photo": "assets/img/home_img_exito.jpg"
    },
    oneColAreaButtonH1_params: {
        "preTitle": "ESG",
        "title": "ayudamos a las personas y empresas a encontrar el local retail que necesitan",
        "mainText": "Por un crecimiento inclusivo y sostenible, mediante la integración de criterios sociales, medioambientales y de buen gobierno.",
        "mainButtonText": "Ver más",
        "mainButtonLink": "/esg/"
    }



}
